
import PropTypes from 'prop-types'
import SortableLabel from './page-list-table-header-sortable-label'

import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

const PageListTableHeader = ({ noColumnSort, headers, selected, displayRowsCount, columnsSort, onToggleColumnsSort, onCheckAll }) => {
  const createWidthStyles = (width) => ({
    width: `${width}px`,
    minWidth: `${width}px`,
    maxWidth: `${width}px`,
  })

  const isDriverPage = window.location.pathname.includes('/drivers')
  const isFbtPages = window.location.pathname.includes('/fbt')

  // const onSelectAll = ({ target: { checked } }) =>
  //   onCheckAll(checked)
  return (
    <TableHead>
      <TableRow>
        <TableCell
          sx={{
            margin: 0,
            padding: 0,
            width: '10px',
            minWidth: '10px',
            maxWidth: '10px',
          }}/>

        {headers.map((header, index) => {
          const headerIndex = `page-header-${header}-${index}`

          if (
            (isDriverPage && header.key === 'agreementNo') // hide agreementNo column heading on driver report page
              || (isFbtPages && header.key === 'accountName') // hide accountName column heading on fbt page
          )
          {return null}

          if (typeof header === 'string') {
            return (
              <TableCell key={headerIndex}>
                {header}
              </TableCell>
            )
          }

          if (header.key === 'checkbox') { // Checkbox column header
            return (
              <TableCell key={headerIndex} className="ignore" style={{ width: 30, minWidth: 30, maxWidth: 30, padding: 0 }}>
              </TableCell>
            )
          }

          if (header && header.visible && header.label) {

            const css = header.width
              ? createWidthStyles(header.width)
              : {}

            if (header.sortKey && columnsSort) {
              return (
                <TableCell key={headerIndex} style={css}>
                  <SortableLabel
                    toggleAction={header.toggleAction}
                    toggleValue={header.toggleValue}
                    showToggle={header.showToggle}
                    toolTip={header.toolTip}
                    noSort={noColumnSort}
                    active={header.sortKey === columnsSort.column}
                    center={header.center}
                    direction={columnsSort.direction}
                    onClick={() => onToggleColumnsSort(header.sortKey)}>
                    {header.label}
                  </SortableLabel>
                </TableCell>
              )
            }

            return (
              <TableCell key={headerIndex} style={css}>
                {header.label}
              </TableCell>
            )
          }

          return null
        })}

        {!isDriverPage && (
          <TableCell
            sx={{
              // minWidth: isAdminUsersTable ? 120 : 60,
              flex: 1,
              margin: 0,
              padding: 0,
            }}/>
        )}
      </TableRow>
    </TableHead>
  )
}

const Header = PropTypes.shape({
  center: PropTypes.bool,
  label: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  sortKey: PropTypes.string,
  width: PropTypes.number,
})

PageListTableHeader.propTypes = {
  noColumnSort: PropTypes.bool,
  headers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, Header])).isRequired,
  selected: PropTypes.array,
  displayRowsCount: PropTypes.number,
  columnsSort: PropTypes.shape({ column: PropTypes.string, direction: PropTypes.string }),
  onToggleColumnsSort: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
}

export default PageListTableHeader
